import {Component, ElementRef, Inject, Renderer2} from '@angular/core';
import {UserCardResponse} from "../interface/userCardResponse";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {DEFAULT_CARD_SINGLE_PAGE_LINK_PREFIX} from "../constants/global.constants";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {LinkUtils} from "../utilityClass/linkUtils";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-qr-generate',
  templateUrl: './qr-generate.component.html',
  styleUrl: './qr-generate.component.scss'
})
export class QrGenerateComponent {

  userCard: UserCardResponse;
  qrCode: string;
  amount: number | undefined;
  isUserCardPayment: boolean | undefined;
  isCommissionActive: boolean | undefined;
  customUrl: string | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<QrGenerateComponent>,
    private snackBarUtil: SnackBarUtil,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private linkUtils: LinkUtils,
    private translate: TranslateService,
  ) {
    this.userCard = data.userCard;
    this.qrCode = data.qrCodeUrl;
    this.amount = data.amount;
    this.isUserCardPayment = data.isUserCardPayment;
    this.isCommissionActive = data.isCommissionActive;
    this.customUrl = data.customUrl;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getBaseUrl(): string {
    return window.location.origin;
  }

  copyLinkToClipboard(): void {
    const cardLink = this.customUrl ?? this.getCardLink(this.userCard.qrUsername);
    navigator.clipboard.writeText(cardLink).then(() => {
      this.translate.get('copy_success.url_copy_success_alert').subscribe((res: string) => {
        this.showSnackbar(MockupDataModel.success(res), SnackBarUtil.CLASSES.success);
      });
    });
  }

  copyPaymentLinkToClipboard(): void {
    const paymentLink = this.getPaymentCardLink();
    navigator.clipboard.writeText(paymentLink).then(() => {
      this.translate.get('copy_success.url_copy_success_alert').subscribe((res: string) => {
        this.showSnackbar(MockupDataModel.success(res), SnackBarUtil.CLASSES.success);
      });
    });
  }

  shareLink(): void {
    const link = this.customUrl
      ?? (this.isUserCardPayment ? this.getCardLink(this.userCard.qrUsername) : this.getPaymentCardLink());
    if (navigator.share) {
      navigator.share({
        title: 'Share QR Code',
        text: 'Check out this QR Code!',
        url: link
      });
    }
  }

  saveImage(): void {
    const imageSrc = this.qrCode;
    const link = this.renderer.createElement('a');
    this.renderer.setAttribute(link, 'href', imageSrc);
    this.renderer.setAttribute(link, 'download', 'qr_code.png');
    this.renderer.setStyle(link, 'display', 'none');
    this.renderer.appendChild(this.elRef.nativeElement.ownerDocument.body, link);
    link.click();
    this.renderer.removeChild(this.elRef.nativeElement.ownerDocument.body, link);
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 1000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  protected isFromUserCardPaymentPage(): boolean {
    return this.isUserCardPayment != undefined && this.isUserCardPayment;
  }

  private getPaymentCardLink(): string {
    return this.linkUtils.getPaymentCardLink(String(this.amount), this.isCommissionActive);
  }

  private getCardLink(qrUsername: string): string {
    return `${this.getBaseUrl()}${DEFAULT_CARD_SINGLE_PAGE_LINK_PREFIX}${qrUsername}`;
  }
}
